import _ from 'lodash';
import * as actions from '../actions/constants';

const initialState = {
  authorized: false,
  comingSoon: false,
  courseAbstract: {
    id: null,
    loading: true,
    productModelId: null,
  },
  navigationBar: [],
  error: null,
  loaded: false,
  overviewWidget: null,
  skills: {
    feedbackSummary: {
      activeFeedback: null,
      error: null,
      expireAt: null,
      feedbackData: {},
      feedbackGoals: [],
      loading: true,
      reportTitle: null,
    },
    notReviewedFeedbackSummary: {
      data: [],
      error: null,
      expireAt: null,
      loading: true,
      reportTitle: null,
    },
    reflectionSummary: {
      activeDraft: null,
      allStudents: null,
      dropDownObject: null,
      error: null,
      expireAt: null,
      loading: true,
      reportTitle: null,
    },
    reflectionTrends: {
      error: null,
      expireAt: null,
      loading: true,
      trends: null,
    },
    revisionPlansNotStarted: {
      data: [],
      error: null,
      expireAt: null,
      loading: true,
      reportTitle: null,
    },
  },
  revisionPlanWidget: null,
  skillsOverview: null,
  skillsNavigation: {},
  studentOverview: null,
  studentReportCollection: {},
  studentUnitReport: null,
  studentUnitReportCollection: {},
  studentSubunitReport: null,
  studentSubunitReportCollection: {},
  subunitList: {
    subunits: null,
    activeSubunit: null,
  },
  subunitReport: null,
  subunitReportCollection: {},
  unitList: {
    activeUnit: null,
    studentActiveUnit: null,
    units: null,
  },
  unitOverview: null,
  unitReport: null,
  unitReportCollection: {},
  dashboard: {
    widgets: [],
  },
  insightsTab: null,
};

const buildUpdatedNav = (nodes, nodeToUpdate, isActivation) => {
  const newNodes = [];
  for (let i = 0; i < nodes.length; i++) {
    const node = { ...nodes[i] };

    node.dataTestId = 'reports-left-nav-link';

    if (isActivation) {
      node.active = false;
    }

    if (
      nodeToUpdate &&
      nodeToUpdate.id === node.id &&
      nodeToUpdate.type === node.type
    ) {
      node.expanded = !Object.prototype.hasOwnProperty.call(
        nodeToUpdate,
        'expanded'
      )
        ? !node.expanded
        : nodeToUpdate.expanded;
      node.active = !Object.prototype.hasOwnProperty.call(
        nodeToUpdate,
        'active'
      )
        ? node.active
        : nodeToUpdate.active;
    }

    if (node.nodes) {
      node.nodes = buildUpdatedNav(node.nodes, nodeToUpdate, isActivation);

      if (isActivation) {
        const anyChildActive = !!_.find(node.nodes, { active: true });
        node.active = node.type === 'root' ? false : anyChildActive;
        node.expanded = node.expanded || anyChildActive;
      }
    }

    newNodes.push(node);
  }
  return newNodes;
};

function report(state = initialState, action) {
  const reportsState = _.cloneDeep(state);
  switch (action.type) {
    case actions.GET_COURSE_ABSTRACT: {
      reportsState.courseAbstract = {
        ...reportsState.courseAbstract,
        ...action.payload,
      };
      return reportsState;
    }
    case actions.SET_NAVIGATION_BAR: {
      reportsState.navigationBar = action.payload;
      return reportsState;
    }
    case actions.SET_NAVIGATION_NODES_STATE: {
      const newNav = buildUpdatedNav(
        reportsState.navigationBar,
        action.payload.node,
        action.payload.isActivation
      );
      reportsState.navigationBar = newNav;
      return reportsState;
    }
    case actions.GET_DASHBOARD: {
      return {
        ...state,
        dashboard: {
          ...action.payload,
        },
      };
    }
    case actions.DELETE_DASHBOARD_WIDGET: {
      const dashboardWidgetId = action.payload.dashboardWidgetId;
      return {
        ...state,
        dashboard: {
          ...state.dashboard,
          widgets: state.dashboard.widgets.filter(
            (w) => w.dashboardWidgetId !== dashboardWidgetId
          ),
        },
      };
    }
    case actions.GET_QQ_OVERVIEW_REPORT: {
      reportsState.unitOverview = {
        ...reportsState.unitOverview,
        ...action.payload,
      };
      return reportsState;
    }
    case actions.GET_SKILLS_OVERVIEW_REPORT: {
      reportsState.skillsOverview = {
        ...reportsState.skillsOverview,
        ...action.payload,
      };
      return reportsState;
    }
    case actions.GET_WIDGET_REPORT: {
      reportsState.overviewWidget = action.payload;
      return reportsState;
    }
    case actions.GET_STUDENT_OVERVIEW_REPORT: {
      reportsState.studentOverview = {
        ...reportsState.studentOverview,
        ...action.payload,
      };
      return reportsState;
    }
    case actions.ADD_STUDENT_OVERVIEW_REPORT: {
      reportsState.studentReportCollection[action.payload.studentId] =
        action.payload.data;
      return reportsState;
    }
    case actions.GET_REVISION_PLAN_WIDGET: {
      reportsState.revisionPlanWidget = action.payload;
      return reportsState;
    }
    case actions.GET_QQ_STUDENT_UNIT_REPORT: {
      reportsState.studentUnitReport = {
        ...action.payload,
      };
      return reportsState;
    }
    case actions.SET_STUDENT_ACTIVE_UNIT: {
      reportsState.unitList = {
        ...reportsState.unitList,
        studentActiveUnit: { ...action.payload },
      };
      return reportsState;
    }
    case actions.ADD_STUDENT_UNIT_REPORT: {
      reportsState.studentUnitReportCollection[action.payload.key] =
        action.payload.data;
      return reportsState;
    }
    case actions.GET_QQ_STUDENT_SUBUNIT_REPORT: {
      reportsState.studentSubunitReport = {
        ...reportsState.studentSubunitReport,
        ...action.payload,
      };
      return reportsState;
    }
    case actions.SET_STUDENT_ACTIVE_SUBUNIT: {
      reportsState.unitList = {
        ...reportsState.unitList,
        studentActiveSubunit: { ...action.payload },
      };
      return reportsState;
    }
    case actions.ADD_STUDENT_SUBUNIT_REPORT: {
      reportsState.studentSubunitReportCollection[action.payload.key] =
        action.payload.data;
      return reportsState;
    }
    case actions.SET_INDIVIDUAL_REPORT_LOADING: {
      if (!reportsState[action.payload.reportKey]) {
        reportsState[action.payload.reportKey] = {};
      }
      reportsState[action.payload.reportKey].loading = action.payload.value;
      return reportsState;
    }
    case actions.SET_REPORTS_AUTH: {
      reportsState.authorized = action.payload;
      return reportsState;
    }
    case actions.SET_UNIT_LIST_LOADING: {
      reportsState.unitList.loading = action.payload;
      return reportsState;
    }
    case actions.SET_SUBUNIT_LIST_LOADING: {
      reportsState.subunitList.loading = action.payload;
      return reportsState;
    }
    case actions.SET_SKILLS_NAVIGATION_LOADING: {
      reportsState.skillsNavigation.loading = action.payload;
      return reportsState;
    }
    case actions.GET_SKILLS_NAVIGATION: {
      reportsState.skillsNavigation = {
        ...reportsState.skillsNavigation,
        ...action.payload,
      };
      return reportsState;
    }
    case actions.GET_UNIT_LIST: {
      reportsState.unitList = {
        ...reportsState.unitList,
        ...action.payload,
      };
      return reportsState;
    }
    case actions.SET_ACTIVE_UNIT: {
      reportsState.unitList = {
        ...reportsState.unitList,
        activeUnit: { ...action.payload },
      };
      return reportsState;
    }
    case actions.GET_SUBUNIT_LIST: {
      reportsState.subunitList = {
        ...reportsState.subunitList,
        ...action.payload,
      };
      return reportsState;
    }
    case actions.SET_ACTIVE_SUBUNIT: {
      reportsState.subunitList = {
        ...reportsState.subunitList,
        activeSubunit: { ...action.payload },
      };
      return reportsState;
    }
    case actions.GET_UNIT_REPORT: {
      reportsState.unitReport = {
        ...reportsState.unitReport,
        ...action.payload,
        error: action.payload.error || null,
      };
      return reportsState;
    }
    case actions.GET_SUBUNIT_REPORT: {
      reportsState.subunitReport = {
        ...reportsState.subunitReport,
        ...action.payload,
      };
      return reportsState;
    }
    case actions.ADD_UNIT_REPORT: {
      reportsState.unitReportCollection[action.payload.unitId] =
        action.payload.data;
      return reportsState;
    }
    case actions.ADD_SUBUNIT_REPORT: {
      reportsState.subunitReportCollection[action.payload.subunitId] =
        action.payload.data;
      return reportsState;
    }
    case actions.SET_REPORTS_LOADING: {
      if (!reportsState.courseAbstract) {
        reportsState.courseAbstract = {};
      }
      reportsState.courseAbstract.loading = action.payload;
      return reportsState;
    }
    case actions.SET_REPORTS_LOADED: {
      reportsState.loaded = action.payload;
      return reportsState;
    }
    case actions.SET_REPORTS_COMING_SOON: {
      reportsState.comingSoon = action.payload;
      return reportsState;
    }
    case actions.FETCHING_REFLECTIONS_SUMMARY_TRENDS_DATA: {
      reportsState.skills.reflectionSummary.loading = true;
      reportsState.skills.reflectionSummary.reportTitle =
        action.payload.reflectionSummary.reportTitle;
      reportsState.skills.reflectionTrends.loading = true;
      return reportsState;
    }
    case actions.FETCHED_REFLECTIONS_SUMMARY_TRENDS_DATA: {
      reportsState.skills.reflectionSummary = {
        ...action.payload.reflectionSummary,
        error: null,
        loading: false,
      };
      reportsState.skills.reflectionTrends = {
        ...action.payload.reflectionTrends,
        error: null,
        loading: false,
      };
      return reportsState;
    }
    case actions.FAILED_FETCH_REFLECTIONS_SUMMARY_TRENDS_DATA: {
      reportsState.skills.reflectionSummary = {
        error: action.payload.error,
        loading: false,
      };
      reportsState.skills.reflectionTrends = {
        error: action.payload.error,
        loading: false,
      };
      return reportsState;
    }
    case actions.UPDATE_ACTIVE_DRAFT_REFLECTIONS_SUMMARY: {
      reportsState.skills = {
        ...reportsState.skills,
        reflectionSummary: {
          ...reportsState.skills.reflectionSummary,
          activeDraft: action.payload,
        },
      };
      return reportsState;
    }
    case actions.FETCHING_NOT_REVIEWED_FEEDBACK_SUMMARY_REPORT: {
      reportsState.skills.notReviewedFeedbackSummary.loading = true;
      reportsState.skills.notReviewedFeedbackSummary.error = null;
      reportsState.skills.notReviewedFeedbackSummary.reportTitle =
        action.payload.reportTitle;
      return reportsState;
    }
    case actions.FETCHED_NOT_REVIEWED_FEEDBACK_SUMMARY_REPORT: {
      reportsState.skills.notReviewedFeedbackSummary = {
        data: action.payload.notReviewedFeedbackSummaryData,
        error: null,
        expireAt: action.payload.expireAt,
        loading: false,
        reportTitle: action.payload.reportTitle,
      };
      return reportsState;
    }
    case actions.FAILED_FETCH_NOT_REVIEWED_FEEDBACK_SUMMARY_REPORT: {
      reportsState.skills.notReviewedFeedbackSummary.error =
        action.payload.error;
      reportsState.skills.notReviewedFeedbackSummary.loading = false;
      reportsState.skills.notReviewedFeedbackSummary.reportTitle =
        action.payload.reportTitle;
      return reportsState;
    }
    case actions.FETCHING_SKILLS_FEEDBACK_SUMMARY_REPORT: {
      reportsState.skills.feedbackSummary = {
        error: null,
        loading: true,
        reportTitle: action.payload.reportTitle,
      };
      return reportsState;
    }
    case actions.FETCHED_SKILLS_FEEDBACK_SUMMARY_REPORT: {
      reportsState.skills.feedbackSummary = {
        activeFeedback: action.payload.activeFeedback,
        error: null,
        expireAt: action.payload.expireAt,
        feedbackData: action.payload.feedbackData,
        feedbackGoals: action.payload.feedbackGoals,
        reportTitle: action.payload.reportTitle,
        loading: false,
      };
      return reportsState;
    }
    case actions.FAILED_FETCH_SKILLS_FEEDBACK_SUMMARY_REPORT: {
      reportsState.skills.feedbackSummary = {
        error: action.payload.error,
        loading: false,
        reportTitle: action.payload.reportTitle,
      };
      return reportsState;
    }
    case actions.UPDATE_ACTIVE_FEEDBACK_SKILLS_REPORT: {
      reportsState.skills.feedbackSummary = {
        ...reportsState.skills.feedbackSummary,
        activeFeedback: action.payload,
      };
      return reportsState;
    }
    case actions.FETCHING_REVISION_PLANS_NOT_STARTED: {
      reportsState.skills.revisionPlansNotStarted.loading = true;
      reportsState.skills.revisionPlansNotStarted.error = null;
      reportsState.skills.revisionPlansNotStarted.reportTitle =
        action.payload.reportTitle;
      return reportsState;
    }
    case actions.FETCHED_REVISION_PLANS_NOT_STARTED: {
      reportsState.skills.revisionPlansNotStarted = {
        ...action.payload,
        error: null,
        loading: false,
      };
      return reportsState;
    }
    case actions.FAILED_FETCH_REVISION_PLANS_NOT_STARTED: {
      reportsState.skills.revisionPlansNotStarted.error = action.payload.error;
      reportsState.skills.revisionPlansNotStarted.loading = false;
      return reportsState;
    }
    case actions.APP_LOGOUT:
    case actions.CLEAR_REPORTS: {
      return initialState;
    }
    case actions.SET_INSIGHTS_TAB: {
      return {
        ...reportsState,
        insightsTab: action.payload,
      };
    }
    default:
      return state;
  }
}

report.constants = {
  initialState,
};

export default report;
